export default "__VITE_ASSET__BR9Pyknh__"